module.exports = __webpack_public_path__ + "static/media/17a-01-HOME_ST-2017-280x350cm-oleo-sobre-madera.bbf9f68c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17a/17a-01-HOME_ST-2017-280x350cm-oleo-sobre-madera.jpg
// module id = 204
// module chunks = 0